import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import loanFormModel from '../../form_models/loanFormModel';
import * as Yup from 'yup';
import PropertyTenantWillingToBeCommercialGuarantorRuleset from '../../business/ruleset/PropertyTenantWillingToBeCommercialGuarantorRuleset';

const { propertyTenantWillingToBeCommercialGuarantor } =
  loanFormModel.formField;

export class PropertyTenantWillingToBeCommercialGuarantorValidation
  implements ValidationSchema
{
  public name = propertyTenantWillingToBeCommercialGuarantor.name;
  public label = propertyTenantWillingToBeCommercialGuarantor.label;
  public type = 'string';

  public required = {
    message: '',
    value: false,
  };

  public nullable = true;
  public ruleset = PropertyTenantWillingToBeCommercialGuarantorRuleset;

  public when(schema: Yup.StringSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('This field is required');

    return schema;
  }
}
export default new Validation(
  new PropertyTenantWillingToBeCommercialGuarantorValidation()
);
